import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  assessmentData: null,
  dependencies: {
    occupationId: null,
    currentJob: null,
    currentJobDescription: null,
    selectedCareer: null,
  },
  isLoading: false,
  error: null,
  lastFetched: null,
};

const assessmentSlice = createSlice({
  name: 'assessment',
  initialState,
  reducers: {
    setAssessmentData: (state, action) => {
      state.assessmentData = action.payload.data;
      state.dependencies = action.payload.dependencies;
      state.isLoading = false;
      state.error = null;
      state.lastFetched = new Date().toISOString();
    },
    setAssessmentLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setAssessmentError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    clearAssessmentData: (state) => {
      state.assessmentData = null;
      state.dependencies = {
        occupationId: null,
        currentJob: null,
        currentJobDescription: null,
        selectedCareer: null,
      };
      state.isLoading = false;
      state.error = null;
      state.lastFetched = null;
    },
  },
});

export const {
  setAssessmentData,
  setAssessmentLoading,
  setAssessmentError,
  clearAssessmentData,
} = assessmentSlice.actions;

// Selector to check if dependencies have changed
export const selectAssessmentDependencies = (state) => state.assessment.dependencies;
export const selectAssessmentData = (state) => state.assessment.assessmentData;
export const selectAssessmentLoading = (state) => state.assessment.isLoading;
export const selectAssessmentError = (state) => state.assessment.error;
export const selectLastFetched = (state) => state.assessment.lastFetched;

// Selector to check if current dependencies match stored dependencies
export const selectDependenciesChanged = (state) => {
  const { occupationId, currentJob, currentJobDescription, selectedCareer } = state.user;
  const storedDeps = state.assessment.dependencies;
  
  return (
    storedDeps.occupationId !== occupationId ||
    storedDeps.currentJob !== currentJob ||
    storedDeps.currentJobDescription !== currentJobDescription ||
    storedDeps.selectedCareer !== selectedCareer
  );
};

export default assessmentSlice.reducer;
